export class User {

    public fullName!: String
    public birthdate!: Date
    public cellphone!: String
    public cpf!: String
    public userType!: string

}
